import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy,Component,Input } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyListModule } from '@angular/material/legacy-list';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { ResolveData,RouterLink } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { Store } from '@ngrx/store';
import { BehaviorSubject,combineLatest,firstValueFrom,Observable,of } from 'rxjs';
import { distinctUntilChanged, filter, map, shareReplay, switchMap, tap } from 'rxjs/operators';
import { AddReportButtonComponent } from '../../../../../add-report-button/add-report-button.component';
import { BlueprintComponent } from '../../../../../blueprint/blueprint.component';
import { DaveCommentsModule } from '../../../../../dave-comments/dave-comments.module';
import { CommentEntityTypeEnum } from '../../../../../dave-data-module/entities/comment.entity';
import { CommissionEntity } from '../../../../../dave-data-module/entities/commission.entity';
import { CommissionTypeEntity } from '../../../../../dave-data-module/entities/commissionType.entity';
import { CustomerEntity } from '../../../../../dave-data-module/entities/customer.entity';
import { EventTypeEntity,interruptionEventTypeNames } from '../../../../../dave-data-module/entities/event-type.entity';
import { EventEntity } from '../../../../../dave-data-module/entities/event.entity';
import { FolderEntity,FolderTypes } from '../../../../../dave-data-module/entities/folder.entity';
import { GeneratedDocumentsEntity } from '../../../../../dave-data-module/entities/generatedDocuments.entity';
import {
    GeneratedDocumentsTypeEntity,
    GeneratedDocumentsTypeSlugs,
} from '../../../../../dave-data-module/entities/generatedDocumentsType.entity';
import { Person2EntityEntityTypeEnum } from '../../../../../dave-data-module/entities/person2entity.entity';
import { CommissionResolver } from '../../../../../dave-data-module/guards/commission.resolver';
import { CommissionTypeResolver } from '../../../../../dave-data-module/guards/commissionType.resolver';
import { ComplaintTypeResolver } from '../../../../../dave-data-module/guards/complaintType.resolver';
import { CustomerResolver } from '../../../../../dave-data-module/guards/customer.resolver';
import { EventTypeResolver } from '../../../../../dave-data-module/guards/event-type.resolver';
import { GeneratedDocumentsResolver } from '../../../../../dave-data-module/guards/generatedDocuments.resolver';
import { GeneratedDocumentsTypeResolver } from '../../../../../dave-data-module/guards/generatedDocumentsType.resolver';
import { getFetched$ } from '../../../../../dave-data-module/helper/helper';
import { FolderDataService } from '../../../../../dave-data-module/services/folder-data.service';
import { State } from '../../../../../dave-data-module/State';
import { FileUploadParams } from '../../../../../dave-data-module/State/actions/files.actions';
import { commissionsFeatureKey } from '../../../../../dave-data-module/State/reducers/commission.reducer';
import { CommissionTypesFeatureKey } from '../../../../../dave-data-module/State/reducers/commissionType.reducer';
import { complaintTypesFeatureKey } from '../../../../../dave-data-module/State/reducers/complaintType.reducer';
import { customersFeatureKey } from '../../../../../dave-data-module/State/reducers/customers.reducer';
import { EVENT_TYPE_FEATURE_KEY } from '../../../../../dave-data-module/State/reducers/event-types.reducer';
import { generatedDocumentsFeatureKey } from '../../../../../dave-data-module/State/reducers/generatedDocuments.reducer';
import { generatedDocumentsTypesFeatureKey } from '../../../../../dave-data-module/State/reducers/generatedDocumentsType.reducer';
import { getCommissionById } from '../../../../../dave-data-module/State/selectors/commission.selector';
import { getCommissionTypeById } from '../../../../../dave-data-module/State/selectors/commissionType.selectors';
import { getComplaintTypes,getComplaintTypesFetched } from '../../../../../dave-data-module/State/selectors/complaintType.selectors';
import { getCustomerById } from '../../../../../dave-data-module/State/selectors/customers.selectors';
import { getEventTypeFetched,getEventTypes } from '../../../../../dave-data-module/State/selectors/event-type.selector';
import { getGeneratedDocuments,getGeneratedDocumentsFetched } from '../../../../../dave-data-module/State/selectors/generatedDocuments.selectors';
import { getGeneratedDocumentsTypes,getGeneratedDocumentsTypesFetched } from '../../../../../dave-data-module/State/selectors/generatedDocumentsType.selectors';
import { DaveDoubleIconModule } from '../../../../../dave-double-icon/dave-double-icon.module';
import { DaveFileExplorerModule } from '../../../../../dave-file-explorer/dave-file-explorer.module';
import { DaveListCardModule } from '../../../../../dave-list-card/dave-list-card.module';
import { AppButtonModule } from '../../../../../dave-utils-module/app-button-module/app-button.module';
import { MapDialogComponent } from '../../../../../dave-utils-module/dave-shared-components-module/components/dialogs/map-dialog/map-dialog.component';
import { PermissionService } from '../../../../../dave-utils-module/dave-shared-components-module/services/permission.service';
import { Address,DaveHeaderHeight,getAddressString,getNavigationURL,isNotNullOrUndefined } from '../../../../../helper/helper';
import { CommissionMeta,ContactBookMeta,GeneratedDocumentsPageMeta } from '../../../../../helper/page-metadata';
import { CustomLabelService } from '../../../../../services/custom-label/custom-label.service';
import { CommissionSchedulerComponent } from '../../../commission-overview/components/commission-scheduler/commission-scheduler.component';
import { DetailCommissionEventListModule } from '../../detail-commission-event-list/detail-commission-event-list.module';
import { InterruptionEventService } from '../../interruption-events-list-card/interruption-event.service';
import { InterruptionEventsListCardComponent } from '../../interruption-events-list-card/interruption-events-list-card.component';
import { InvolvedPersonsListComponent } from '../../involved-persons-list/involved-persons-list.component';
import { ReportDialogOptions } from '@sentry/angular';
import {
    DocumentEditorDialogComponent, DocumentEditorDialogComponentCloseData, DocumentEditorDialogComponentDialogData,
} from '../../../../../dave-document-editor-module/components/document-editor-dialog/document-editor-dialog.component';

@Component({
    selector: 'app-small-commission-overview',
    standalone: true,
    imports: [
        CommonModule,
        AppButtonModule,
        FontAwesomeModule,
        MatTooltipModule,
        DaveCommentsModule,
        BlueprintComponent,
        DetailCommissionEventListModule,
        MatExpansionModule,
        MatTabsModule,
        InterruptionEventsListCardComponent,
        RouterLink,
        DaveFileExplorerModule,
        InvolvedPersonsListComponent,
        CommissionSchedulerComponent,
        MatLegacyListModule,
        DaveListCardModule,
        DaveDoubleIconModule,
        AddReportButtonComponent,
    ],
    templateUrl: './small-commission-overview.component.html',
    styleUrls: ['./small-commission-overview.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SmallCommissionOverviewComponent {
    public static readonly RequiredResolvers: ResolveData = {
        [CommissionTypesFeatureKey]: CommissionTypeResolver,
        [commissionsFeatureKey]: CommissionResolver,
        [customersFeatureKey]: CustomerResolver,
        [EVENT_TYPE_FEATURE_KEY]: EventTypeResolver,
        [complaintTypesFeatureKey]: ComplaintTypeResolver,
        [generatedDocumentsTypesFeatureKey]: GeneratedDocumentsTypeResolver,
        [generatedDocumentsFeatureKey]: GeneratedDocumentsResolver,
        ...InvolvedPersonsListComponent.RequiredResolvers,
        ...CommissionSchedulerComponent.RequiredResolvers,
    };
    protected commissionId$ = new BehaviorSubject<number>(null);
    @Input() set commissionId(v: number) {
        if (this.commissionId$.value !== v) {
            this.commissionId$.next(v);
        }
    }
    protected commission$: Observable<CommissionEntity>;
    protected commissionRouterLink$: Observable<string[] | null>;
    protected customer$: Observable<CustomerEntity>;
    protected commissionType$: Observable<CommissionTypeEntity>;
    protected commissionAddress$: Observable<Address>;
    protected navigationUrl$: Observable<string>;
    protected addressLabel$: Observable<string>;
    protected interruptionEventTypes$: Observable<EventTypeEntity[]>;
    protected folder$: Observable<FolderEntity | null>;
    protected beteiligtePersonenComplainTypeId$: Observable<number>;
    protected interruptionEventCounts: number[] = [];
    protected generatedDocumentTypesForConstructionDiaryCounts: number[] = [];
    protected interruptionEventsCountSum: number = null;
    protected generatedDocumentTypesForConstructionDiaryCountsSum: number = null;
    protected commentFileUploadParams$: Observable<FileUploadParams>;
    protected generatedDocumentTypesForConstructionDiary$: Observable<GeneratedDocumentsTypeEntity[]>;
    protected generatedDocumentTypesForConstructionDiaryVM$: Observable<{ header: string; slug: GeneratedDocumentsTypeSlugs, generatedDocuments$: Observable<GeneratedDocumentsEntity[]> }[]>;
    protected hasGeneratedDocumentTypesForConstructionDiary$: Observable<boolean>;

    constructor(
        store: Store<State>,
        folderDataService: FolderDataService,
        private dialog: MatDialog,
        protected ps: PermissionService,
        private interruptionEventService: InterruptionEventService,
        protected cls: CustomLabelService,
        generatedDocumentsTypesResolver: GeneratedDocumentsTypeResolver,
        generatedDocsRes: GeneratedDocumentsResolver,
    ) {
        firstValueFrom(store.select(getGeneratedDocumentsFetched)).then((fetched) => {
            if (!fetched) {
                generatedDocsRes.resolve();
            }
        });
        firstValueFrom(store.select(getGeneratedDocumentsTypesFetched)).then((fetched) => {
            if (!fetched) {
                generatedDocumentsTypesResolver.resolve();
            }
        });
        this.commission$ = this.commissionId$.pipe(
            switchMap((id) => store.select(getCommissionById({ id }))),
            filter(isNotNullOrUndefined),
        );
        this.commissionRouterLink$ = this.commission$.pipe(map((commission) => (commission ? ['/', CommissionMeta.Path, commission.Id + ''] : null)));
        this.customer$ = this.commission$.pipe(switchMap((commission) => (commission.CustomerId ? store.select(getCustomerById({ id: commission.CustomerId })) : of(null))));
        this.folder$ = this.commissionId$.pipe(switchMap((commissionId) => folderDataService.getFolderFromEntity(commissionId, FolderTypes.commission)));
        // this.rootCommissionId$ = this.commissionId$.pipe(
        //     switchMap((commissionId) =>
        //         store.select(getCommissionDictionary).pipe(
        //             map((commissions) => {
        //                 let commission = commissions[commissionId];
        //                 let i = 0;
        //                 while (commission?.ParentId && i < 1000) {
        //                     i++;
        //                     commission = commissions[commission.ParentId];
        //                 }
        //                 return commission.Id;
        //             }),
        //         ),
        //     ),
        //     distinctUntilChanged(),
        // );
        this.beteiligtePersonenComplainTypeId$ = getFetched$(store, getComplaintTypesFetched, getComplaintTypes).pipe(map((complaintTypes) => complaintTypes.find((ct) => ct.Name.toLowerCase().includes('beteiligte person'))?.Id));

        this.commissionType$ = this.commission$.pipe(switchMap((commission) => (commission.CommissionTypeId ? store.select(getCommissionTypeById({ id: commission.CommissionTypeId })) : of(null))));
        this.commissionAddress$ = this.commission$.pipe(
            map((commission) => {
                if (commission.Street || commission.PostalCode || commission.City || commission.Country) {
                    return commission;
                }
                return null;
            }),
        );
        this.navigationUrl$ = this.commissionAddress$.pipe(map((address) => address && getNavigationURL(null, address)));
        this.addressLabel$ = this.commissionAddress$.pipe(map((address) => getAddressString(address)));

        this.interruptionEventTypes$ = getFetched$(store, getEventTypeFetched, getEventTypes).pipe(map((eventTypes) => interruptionEventTypeNames.map((name) => eventTypes.find((et) => et.Name === name)).filter(isNotNullOrUndefined)));
        this.commentFileUploadParams$ = this.folder$.pipe(
            map(
                (folder) =>
                    folder &&
                    new Map([
                        ['folder_id', folder.Id.toString()],
                        ['hidden', 'true'],
                    ]),
            ),
        );
        this.generatedDocumentTypesForConstructionDiary$ = getFetched$(store, getGeneratedDocumentsTypesFetched, getGeneratedDocumentsTypes).pipe(
            map((denDocTypes) => {
                return denDocTypes.filter((denDocType) => denDocType.IsErhebungsblatt);
            }),
            shareReplay({ bufferSize: 1, refCount: true }),
        );
        this.generatedDocumentTypesForConstructionDiaryVM$ = this.generatedDocumentTypesForConstructionDiary$.pipe(
            map(types => types.slice().map(v => ({Id: v.Id, Name: v.Name, Slug: v.Slug})).sort((a, b) => a.Id - b.Id)),
            distinctUntilChanged((a,b) => JSON.stringify(a) === JSON.stringify(b)),
            map((types) => {
                return types.map((t) => {
                    return {
                        header: t.Name,
                        slug: t.Slug,
                        generatedDocuments$: combineLatest([getFetched$(store, getGeneratedDocumentsFetched, getGeneratedDocuments), this.commissionId$]).pipe(
                            map(([docs, commissionId]) => docs.filter((d) => d.GeneratedDocumentsTypeId === t.Id && d.CommissionId === commissionId)),
                        ),
                    };
                });
            }),
        );
        this.hasGeneratedDocumentTypesForConstructionDiary$ = this.generatedDocumentTypesForConstructionDiary$.pipe(map((types) => types.length > 0), distinctUntilChanged());
    }
    protected openMapDialog(location: Address) {
        this.dialog.open(MapDialogComponent, {
            ...MapDialogComponent.DefaultConfig,
            data: location,
        });
    }
    protected updateInterruptionEventsCount(index: number, value: number) {
        this.interruptionEventCounts[index] = value;
        this.interruptionEventsCountSum = this.interruptionEventCounts.reduce((prev, curr) => prev + curr, 0);
        console.log('updateInterruptionEventsCount', this.interruptionEventsCountSum);
    }
    protected updateGeneratedDocumentTypesForConstructionDiaryCountsSumCount(index: number, value: number) {
        this.generatedDocumentTypesForConstructionDiaryCounts[index] = value;
        this.generatedDocumentTypesForConstructionDiaryCountsSum = this.generatedDocumentTypesForConstructionDiaryCounts.reduce((prev, curr) => prev + curr, 0);
        console.log('updateGeneratedDocumentTypesForConstructionDiaryCountsSumCount', this.generatedDocumentTypesForConstructionDiaryCountsSum);
    }
    public openEditEventDialog(event: Partial<EventEntity>, element?: HTMLElement) {
        this.interruptionEventService.OpenEditEventDialog(event, this.commissionId$.value, element);
    }
    protected readonly CommentEntityTypeEnum = CommentEntityTypeEnum;
    protected readonly HeaderHeight = DaveHeaderHeight;
    protected readonly CommissionMeta = CommissionMeta;
    protected readonly ContactBookMeta = ContactBookMeta;
    protected readonly Person2EntityEntityTypeEnum = Person2EntityEntityTypeEnum;

    getMatGroupTitle(title: string, count: number) {
        if (isNotNullOrUndefined(count)) {
            return title + ' (' + count + ')';
        } else {
            return title;
        }
    }

    protected readonly GeneratedDocumentsPageMeta = GeneratedDocumentsPageMeta;

    openDocDialog(entry: GeneratedDocumentsEntity) {
        this.dialog.open<DocumentEditorDialogComponent, DocumentEditorDialogComponentDialogData, DocumentEditorDialogComponentCloseData>(DocumentEditorDialogComponent, {
            ...DocumentEditorDialogComponent.DefaultConfig,
            data: {
                generatedDocumentId: entry.Id
            }
        })
    }
}
